<ul class="fw-Breadcrumb margin-bottom-0 margin-left-0 padding-left-0">
    <li *ngIf="parent && parent.name" [ngClass]="{'current-parent breadcrumb-truncate': !grandChild,
		'first':((grandChild === null) ||  (grandChild === undefined))? true : grandChild}">
        <a (click)="handleNavigation()">
            {{parent.name | pershingTranslate}}</a>
    </li>
    <i [ngClass]="{'fa fa-angle-double-right margin-left-5 margin-right-5': (child && child.name)}" *ngIf="child && child.name && (secondLevelBreadCrumbsToHide.indexOf(child.name) == -1)"></i>
    <!-- hide second level breadcrumbs if configured in secondLevelBreadCrumbToHide -->
    <li *ngIf="child && child.name && (secondLevelBreadCrumbsToHide.indexOf(child.name) == -1)"
        [ngClass]="{'active last': !grandChild,
                                                'current-parent first': grandChild,
                                            'breadcrumb-truncate':((grandChild === null) ||  (grandChild === undefined))? true : grandChild}">
        <a (click)="handleChildNavigation()">{{child.name | pershingTranslate}}</a>
    </li>
    <i [ngClass]="{'fa fa-angle-double-right margin-left-5 margin-right-5': (grandChild && grandChild.name)}"></i>
    <li *ngIf="grandChild && grandChild.name" 
        [ngClass]="{'active last': !fourthChild, 'current-parent first': fourthChild,
            'breadcrumb-truncate':((fourthChild === null) ||  (fourthChild === undefined))? true : fourthChild}">
        <a (click)="handleGrandChildNavigation()">{{grandChild.name | pershingTranslate}}</a>
    </li>
    <i [ngClass]="{'fa fa-angle-double-right margin-left-5 margin-right-5': (fourthChild && fourthChild.name)}"></i>
    <li *ngIf="fourthChild && fourthChild.name" class="active last breadcrumb-truncate">
        <a (click)="handleFourthChildNavigation(fourthChild)">{{fourthChild.name | pershingTranslate}}</a>
    </li>
</ul>